import { render } from "./PublicAgahi.vue?vue&type=template&id=66a1d69d"
import script from "./PublicAgahi.vue?vue&type=script&lang=js"
export * from "./PublicAgahi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__